import React from "react";
import "./Footer.css";
import { FaGithub, FaLinkedin, FaArrowUp } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">

      <h2>Yamuna Nagireddy</h2>

      <p>
        Python Full Stack Developer | React Developer
      </p>

      <div className="footer-links">

        <a href="/">Home</a>

        <a href="/about">About</a>

        <a href="/projects">Projects</a>

        <a href="/skills">Skills</a>

        <a href="/contact">Contact</a>

      </div>

      <div className="footer-icons">

        <a href="https://github.com/" target="_blank" rel="noreferrer">
          <FaGithub />
        </a>

        <a href="https://linkedin.com/" target="_blank" rel="noreferrer">
          <FaLinkedin />
        </a>

      </div>

      <button
        className="top-btn"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <FaArrowUp />
      </button>

      <p className="copyright">
        © 2026 Yamuna Nagireddy. All Rights Reserved.
      </p>

    </footer>
  );
};

export default Footer;